export const SEARCH_FORM_SUBMIT = 'STAFF.ONLINE_SURVEYS.STUDENTS.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'STAFF.ONLINE_SURVEYS.STUDENTS.SORT_CHANGE';
export const PAGE_CHANGE = 'STAFF.ONLINE_SURVEYS.STUDENTS.PAGE_CHANGE';
export const FETCH_LIST = 'STAFF.ONLINE_SURVEYS.STUDENTS.FETCH_LIST';
